/**
 * Spec №11 (D-M4) — the assembled App Shell sitemap, from the server verb
 * `get_app_sitemap`. Replaces the hardcoded APP_SITEMAP data: the Places axis is
 * merged server-side from installed modules + system entries, ordered, with
 * uninstalled modules' Places returned disabled (greyed).
 */
import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import type { SitemapEntry } from "../routes/app/sitemap";
import type { ShellDefinition } from "../../lib/types";

export interface AppSitemap {
  places: SitemapEntry[];
  /** Spec №14 (14.1) — the post-login landing route resolved from the shell. */
  home?: string;
  /** Spec №14 (D-SH1) — the resolved shell (brand/theme/id), null when none. */
  shell?: ShellDefinition | null;
}

export function useAppSitemap() {
  return useQuery({
    queryKey: ["app-sitemap"],
    staleTime: 60_000,
    queryFn: async () => {
      const r = await mcpClient.toolsCall<AppSitemap>("get_app_sitemap");
      if (r.isError) throw new Error(r.content?.[0]?.text ?? "get_app_sitemap failed");
      return (r.structuredContent as AppSitemap) ?? { places: [] };
    },
  });
}
